<ng-container #dialogContent></ng-container>
